import { CircularProgress, SxProps } from '@mui/material';
import { LoadingContainer } from 'components/layout/LandingPage/landingPage.styles';
import { StyledTitle } from 'components/system/Modal';
import { AUTH_MODAL_Z_INDEX } from 'style/constants';
import { useCloudflareAuth } from '../hooks/useCloudflareAuth';

export const CloudflareLogin = ({
  triggerLogin,
  successCallback,
  sx,
}: {
  triggerLogin?: boolean;
  successCallback?: () => void;
  sx?: SxProps;
}) => {
  const { loading } = useCloudflareAuth(triggerLogin, successCallback);

  return loading ? (
    <LoadingContainer
      sx={{
        zIndex: AUTH_MODAL_Z_INDEX + 1,
        background: 'background.main',
        borderRadius: '20px',
        width: '658px',
        height: '568px',
        position: 'absolute',
        top: '50%',
        left: '50%',
        transform: 'translate(-50%, -50%)',
        ...sx,
      }}
    >
      <StyledTitle variant="h3" align="center">
        Authenticating with cloudflare access...
      </StyledTitle>
      <CircularProgress size={64} />
    </LoadingContainer>
  ) : null;
};
